import { Box, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import { getDealerProspectus, getTasksDetails } from '_controllers/officer';
// import { Bar } from 'react-chartjs-2';
// import { Doughnut } from 'react-chartjs-2';
// import { PieChart } from 'react-minimal-pie-chart';

const Leads = () => {
  const { SAP_ID } = useParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [visitDetails, setVisitDetails] = useState([])
  const [message, setMessage] = useState("");
  const [onDate, setOnDate] = useState('');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [csvData, setCsvData] = useState([]);

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  useEffect(async () => {
    const start = startDate
      ? startDate
      : moment().startOf("month").format("YYYY-MM-DD");

    const end = endDate
      ? endDate
      : moment().endOf("month").format("YYYY-MM-DD");
    const plan = await getDealerProspectus({
      SAP_ID,
      start,
      end,
    });
    console.log("lead", plan.data);
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }, [message]);

  let dataVal = [9, 5, 3]
  let labels = ["Newly Added", "Edited", "Deleted"]

  let customLabels = labels.map((label, index) => `${label}: ${dataVal[index]}`)

  const chartdata = {
    labels: customLabels,
    datasets: [
      {
        label: "Markets Monitored",
        backgroundColor: [
          "#83ce83",
          "#959595",
          "#f96a5d",
          "#00A6B4",
          "#6800B4",
        ],
        data: dataVal,
      },
    ],
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const plan = await getDealerProspectus({
      SAP_ID,
      start: selectStartDate,
      end: selectEndDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const { selectStartDate, selectEndDate } = Values
  const fileName = `${SAP_ID}-Tasks`;

  const generateExcel = async (e) => {
    e.preventDefault()

    exportExcel(csvData.map((x) => {
      return {
        'SAP ID': x?.SAP_ID,
        "Dealer Code": x.dealer.dealerCode,
        'Dealer Name': x.dealer.name,
        'Type': x.type,
        "Subject": x?.subject ? x?.subject : "-",
        'Status': x?.status,
        "Due Date": moment.utc(x?.dueDate).format("DD-MM-YYYY"),
        "Remarks": x?.description,
      }
    }), fileName)
  }

  const dataChart = {
    label: ["mon", "tue", "wed"],
    datasets: [{
      labels: 'SALES',
      data: [3, 4, 5]
    }]
  }

  const options = {
    plugins: {
      legend: true
    },
  }

  const formRef = useRef(null);
  function handleSubmit1(event) {
    event.preventDefault();
    const formData = new FormData(formRef.current);
    // do something with form data, like sending it to a server
  }

  return (
    <>
      {/* // change static data in url endpoint*/}
      <Box sx={{ mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>Start Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectStartDate}
                  name="selectStartDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>End Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectEndDate}
                  name="selectEndDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid>
          </Grid>
        </form>
      </Box>
      {/* <Line
        data={dataChart}
        options={options}
      >

      </Line> */}
      {/* <Bar
        data={chartdata}
      /> */}
      {/* <div style={{ border: '1px solid red', width: '300px' }}>
        <PieChart
          animation
          animationDuration={500}
          animationEasing="ease-out"
          center={[50, 50]}
          data={[
            { title: 'One', value: 10, color: 'red' },
            { title: 'Two', value: 15, color: 'yellow' },
            { title: 'Three', value: 20, color: 'green' },
          ]}
          labelPosition={50}
          lengthAngle={360}
          // lineWidth={15}
          paddingAngle={0}
          radius={50}
          // rounded
          startAngle={0}
          viewBoxSize={[100, 100]}
        />
      </div> */}

      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Date</TableCell> */}
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Firm Name</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Firm Nature</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Address</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Phone</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Lead Type</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Business Nature</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Prospect Type</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Document</TableCell>
                  {/* <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Action</TableCell> */}
                </TableRow>
              </TableHead>

              {data?.length > 0
                ? data?.map((d) => (
                  <TableBody>
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?.basicDetail?.firmName}</TableCell>
                      <TableCell align="left">{d?.basicDetail?.natureOfFirm}</TableCell>
                      <TableCell align="left">{d?.basicDetail?.address1},{d?.basicDetail?.state?.name}</TableCell>
                      <TableCell align="left">{d?.basicDetail?.phoneNumber}</TableCell>
                      <TableCell align="left">{d?.basicDetail?.leadType}</TableCell>
                      <TableCell align="left">{d?.businessDetail?.natureOfBusiness}</TableCell>
                      <TableCell align="left">{d?.businessDetail?.prospectType}</TableCell>
                      <TableCell align="left">{d?.description}</TableCell>
                    </TableRow>
                  </TableBody>
                ))
                :
                <Box sx={{ textAlign: 'left', pt: 1 }}>
                  <Typography variant="h6" sx={{ p: 1 }}>No Prospectus Availabe.</Typography>
                </Box>}
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      {/* <h1>hello</h1>
      <form ref={formRef} onSubmit={handleSubmit1}>
        <label>
          Email:
          <input type="email" name="email" />
        </label>
        <br />
        <label>
          Password:
          <input type="password" name="password" />
        </label>
        <br />
        <button type="submit">Log in</button>
      </form> */}
    </>
  )
}

export default Leads